import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

class IconBox extends React.Component {
  render() {
    const {
      show_icon,
      icon_class,
      title,
      body,
      show_details_button,
      details_button_text,
      onDetailsButtonClick,
      show_selector_button,
      selector_button_text,
      onSelectorButtonClick,
      height,
      CustomComponent,
      type,
      container_class_name,
      loading
    } = this.props;

    const box_style = type == 'primary' ? 'primary' :
    type == 'danger' ? 'secondary' :
    type == 'info' ? 'tertiary' :
    type == 'dark' ? 'quaternary' : 'primary';

    return (
      <div className={container_class_name}>
        <div
          className={`featured-box featured-box-${box_style} featured-box-effect-1`}
          style={{ minHeight: height ? `${height}px` : '381px' }}>
    			<div className='box-content'>
    				{show_icon ? (
              loading ? (
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              ) : (
                <i className={`icon-featured ${icon_class}`} />
              )
            ) : null}
    				{title ? <h4 className='text-uppercase'>{title || '(No Name)'}</h4> : null}
    				{body ? <p>{body}</p> : null}
    				{show_details_button ? (
              <p>
                <a
                  className='lnk-primary learn-more'
                  onClick={onDetailsButtonClick}
                  >
                  {details_button_text || 'Learn More'}{'  '}<i className='fa fa-angle-right' />
                </a>
              </p>
            ) : null}
            {show_selector_button ? (
              <Button onClick={onSelectorButtonClick}>{selector_button_text}</Button>
            ) : null}
            {CustomComponent ? CustomComponent : null}
    			</div>
    		</div>
      </div>
    );
  }
}

IconBox.PropTypes = {
  icon_class: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  show_icon: PropTypes.bool,
  show_details_button: PropTypes.bool,
  details_button_text: PropTypes.string,
  onDetailsButtonClick: PropTypes.func,
  show_selector_button: PropTypes.bool,
  selector_button_text: PropTypes.string,
  onSelectorButtonClick: PropTypes.func,
  height: PropTypes.number,
  type: PropTypes.oneOf([ 'primary', 'danger', 'info', 'dark' ]),
  container_class_name: PropTypes.string
};

export default IconBox;



// WEBPACK FOOTER //
// ./src/browser/components/ui/icon-box.js